import { render, staticRenderFns } from "./AlertSettingsModal.vue?vue&type=template&id=5d3f8680&scoped=true&"
import script from "./AlertSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./AlertSettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AlertSettingsModal.vue?vue&type=style&index=0&id=5d3f8680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f8680",
  null
  
)

export default component.exports